<template>
  <div style="height: calc(100vh - 196px)">
    <vxe-toolbar
      id="toolbarId_bi5"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button @click="funcFilter"> 查询 </el-button>
        <el-button @click="addManaager">
          新增
        </el-button>
        <el-button @click="funcExport"> 导出 </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column>
        <vxe-table-column
          field="companyName"
          min-width="130"
          title="子公司名称"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.companyName"
            placeholder="请输入子公司名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="userName"
          min-width="130"
          title="管理员姓名"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.userName"
            placeholder="请输入管理员姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="phone"
          min-width="130"
          title="手机号"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入手机号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="staffType"
          min-width="130"
          title="角色"
          sortable
        >
          <template v-slot="scope">
            <span>管理员</span>
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-select
            v-model="listQuery.staffType"
            placeholder="请选择角色"
            clearable
          >
            <el-option
              v-for="item in roleOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="subPartyList"
          min-width="150"
          title="绑定子账号"
        >
          <template v-slot="scope">
            <span
              v-if="scope.row.subPartyList && scope.row.subPartyList.length"
            >
              {{
                scope.row.subPartyList.map(item => item.subUserName).join(",")
              }}
            </span>
            <span v-else>--</span>
          </template>
        </vxe-table-column>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          min-width="130"
          title="创建时间"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreated"
            type="datetimerange"
            placeholder="创建时间"
            clearable
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>

      <vxe-table-column min-width="140" title="操作" fixed="right">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <vxe-button type="text" @click="editShipmentApi(scope.row)">
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              scope.row.isPayPermission === 0 && getLimit('openPay_btn_company')
            "
            class="item"
            effect="dark"
            content="开通支付权限"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="updatePayPermissionApi(scope.row.code, 1)"
            >
              <img
                style="width: 18px; height: 18px; position: relative;top:5px;"
                src="@/assets/icon/pay2.png"
                alt=""
              />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              scope.row.isPayPermission === 1 && getLimit('openPay_btn_company')
            "
            class="item"
            effect="dark"
            content="关闭支付权限"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="updatePayPermissionApi(scope.row.code, 0)"
            >
              <img
                style="width: 16px; height: 16px; position: relative;top:4px;"
                src="@/assets/icon/nopay2.png"
                alt=""
              />
            </vxe-button>
          </el-tooltip>
          <!-- 绑定子账号 -->
          <el-tooltip
            v-if="getLimit('opensidiary_btn_company')"
            class="item"
            effect="dark"
            content="绑定子账号"
            placement="top"
          >
            <vxe-button type="text" @click="bindSubsidiaryApi(scope.row)">
              <img
                style="width: 20px; height: 20px; position: relative;top:4px;"
                src="@/assets/icon/bangding.png"
                alt=""
              />
            </vxe-button>
          </el-tooltip>
          <!-- 预付权限开关，仅母公司可操作 -->
          <el-tooltip
            v-if="
              isHasSub === 0 && parentIsShow === 1 && scope.row.isShow === 0
            "
            class="item"
            effect="dark"
            :content="`预付开关: 未开启`"
            placement="top"
          >
            <vxe-button type="text" @click="updateSubShowStatusApi(scope.row)">
              <img
                style="width: 17px; height: 19px; position: relative; top: 4px;"
                src="@/assets/icon/guan.png"
                alt=""
              />
            </vxe-button>
          </el-tooltip>

          <!-- <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <vxe-button type="text" @click="deleteShipmentApi(scope.row.code)">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip> -->
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :page-sizes="Pagingconf"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <!-- 新增子公司弹窗 -->
    <vxe-modal
      v-model="modelAddFlag"
      :title="editType === 'add' ? '新增' : '编辑'"
      width="600"
      resize
      show-footer
      :loading="submitLoading"
      @close="closeAddModal"
    >
      <el-form
        ref="addFormRef"
        :model="addForm"
        :rules="addFormRules"
        label-width="100px"
        class="add-form"
      >
        <el-form-item label="子公司名称" prop="companyName">
          <el-input
            v-model="addForm.companyName"
            placeholder="请输入子公司名称"
            clearable
            maxlength="100"
          />
        </el-form-item>
        <el-form-item label="管理员姓名" prop="userName">
          <el-input
            v-model="addForm.userName"
            placeholder="请输入管理员姓名"
            clearable
            maxlength="50"
          />
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input
            v-model="addForm.phone"
            placeholder="请输入手机号"
            clearable
            maxlength="11"
            :disabled="editType === 'edit'"
          />
        </el-form-item>
        <el-form-item label="角色" prop="staffType">
          <el-select
            v-model="addForm.staffType"
            placeholder="请选择角色"
            clearable
            style="width: 100%"
          >
            <el-option
              v-for="item in roleOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="modal-footer">
          <el-button @click="closeAddModal">取消</el-button>
          <el-button
            type="primary"
            :loading="submitLoading"
            @click="createSubAccApi"
          >
            {{ editType === "add" ? "创建" : "修改" }}
          </el-button>
        </div>
      </template>
    </vxe-modal>
    <!-- 分页 -->
    <downloadData ref="downloadRef" />
    <!--  选择子账号-->
    <vxe-modal
      v-model="bindModalFlag"
      title="绑定子账号"
      width="90%"
      height="80%"
      resize
      @close="closeBindModal"
    >
      <shipmentStaffList
        ref="shipmentStaffListRef"
        :select-shipment="selectShipment"
        :is-binding="true"
        @confirm="funcConfirm"
      />
    </vxe-modal>
  </div>
</template>

<script>
import shipmentStaffList from "./components/shipmentStaff/shipmentStaffList.vue";
import pageMixin from "@/mixins/pageMixin";
import {
  createSubAcc,
  subList,
  deleteShipment,
  editSubAcc,
  updatePayPermission,
  updateSubShowStatus,
  bindSubParty
} from "@/api/EMS";
export default {
  name: "SubsidiaryManagement",
  components: {
    shipmentStaffList
  },
  mixins: [pageMixin],
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          receiverUserCodeOptions: [],
          bankOptions: []
        };
      }
    }
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号"));
        return;
      }
      const reg = /^1[3-9]\d{9}$/;
      if (!reg.test(value)) {
        callback(new Error("请输入正确的手机号"));
        return;
      }
      callback();
    };
    return {
      isHasSub: this.$store.state.user.party.companyType,
      selectShipment: {},
      exportObj: {
        exportUrl: "/ntocc-basic-api/shipment/exportSubList", //导出接口
        name: "子公司列表"
      },
      loading: false,
      modelAddFlag: false,
      submitLoading: false,
      bindModalFlag: false,
      bindParentData: {},
      addForm: {
        staffType: 1,
        userName: "",
        phone: "",
        companyName: ""
      },
      addFormRules: {
        companyName: [
          { required: true, message: "请输入子公司名称", trigger: "blur" },
          { max: 100, message: "长度不能超过100个字符", trigger: "blur" }
        ],
        userName: [
          { required: true, message: "请输入管理员姓名", trigger: "blur" },
          { max: 50, message: "长度不能超过50个字符", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: validatePhone, trigger: "blur" }
        ],
        staffType: [
          { required: true, message: "请选择角色", trigger: "change" }
        ]
      },
      roleOptions: [
        { label: "管理员", value: 1 }
        // 可在此扩展更多角色，如：{ label: "普通用户", value: "user" }
      ],
      tableData: [],
      isInvoiceDefault: [{ label: "否", value: 0 }, { label: "是", value: 1 }],
      listQuery: {
        isInvoiceDefault: "",
        receiverUserCode: "",
        invoiceTitle: "",
        taxRegistrationNumber: "",
        bank: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      editType: ""
    };
  },
  computed: {
    parentIsShow() {
      return this.$store.state.user.party.isShow;
    }
  },
  methods: {
    funcConfirm(selectRecords) {
      console.log("选择的记录", selectRecords);
      let arr = selectRecords.map(item => item.partyCode);
      let data = {
        companyCode: this.selectShipment.companyCode,
        partyCode: this.selectShipment.partyCode,
        subPartyCode: arr,
        operateType: 1
      };
      bindSubParty(data).then(res => {
        if (res.status === 0) {
          this.$message.success("绑定成功");
          this.bindModalFlag = false;
          this.findList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    bindSubsidiaryApi(row) {
      this.selectShipment = row;
      this.bindModalFlag = true;
      this.$nextTick(() => {
        if (this.$refs.shipmentStaffListRef) {
          this.$refs.shipmentStaffListRef.findList();
        }
      });
    },
    closeBindModal() {
      this.bindModalFlag = false;
      this.bindParentData = {};
    },
    async updatePayPermissionApi(code, type) {
      this.$confirm(`确认${type === 0 ? "关闭" : "开通"}支付权限吗？`).then(
        async () => {
          let res = await updatePayPermission({ code, isPayPermission: type });
          if (res.status === 0) {
            this.$message.success("更新成功");
            this.findList();
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
    updateSubShowStatusApi(item) {
      const currentIsShow = item.isShow === 1 ? 1 : 0;
      const isShow = currentIsShow === 1 ? 0 : 1;
      this.$confirm(
        `确认${currentIsShow === 1 ? "关闭" : "开启"}预付权限吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          updateSubShowStatus({
            code: item.code,
            isShow
          }).then(res => {
            if (res.status === 0) {
              this.$message.success("操作成功");
              this.findList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    editShipmentApi(row) {
      this.editType = "edit";
      this.addForm = JSON.parse(JSON.stringify(row));
      this.modelAddFlag = true;
    },
    deleteShipmentApi(code) {
      this.$confirm("确认删除吗？")
        .then(() => {
          deleteShipment({ codes: code })
            .then(res => {
              this.$message.success("删除成功");
              this.findList();
            })
            .catch(err => {
              this.$message.error(err.message);
            });
        })
        .catch(() => {});
    },
    createSubAccApi() {
      this.$refs.addFormRef.validate(valid => {
        if (valid) {
          let api = this.editType === "add" ? createSubAcc : editSubAcc;
          api(this.addForm)
            .then(res => {
              this.$message.success(
                this.editType === "add" ? "创建成功" : "修改成功"
              );
              this.closeAddModal();
              this.findList();
            })
            .catch(err => {
              // this.$message.error(err.message);
            });
        }
      });
    },
    addManaager() {
      this.editType = "add";
      this.resetAddForm();
      this.modelAddFlag = true;
      this.$nextTick(() => {
        this.$refs.addFormRef && this.$refs.addFormRef.clearValidate();
      });
    },
    closeAddModal() {
      this.modelAddFlag = false;
      this.resetAddForm();
      this.$refs.addFormRef && this.$refs.addFormRef.resetFields();
      this.$refs.addFormRef && this.$refs.addFormRef.clearValidate();
    },
    resetAddForm() {
      this.addForm = {
        companyName: "",
        userName: "",
        phone: "",
        staffType: 1
      };
    },

    formatterIsInvoiceDefault({ cellValue }) {
      const item = this.isInvoiceDefault.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    findList() {
      this.loading = true;
      let data = JSON.parse(JSON.stringify(this.listQuery));
      delete data.gmtCreated;
      data.companyCode = this.$route.query.code ? this.$route.query.code : "";
      subList(data)
        .then(res => {
          this.tableData = res.data.records;
          this.listQuery.total = res.data.total;
          this.loading = false;
        })
        .catch(err => {
          this.$message.error(err.message);
          this.loading = false;
        });
    },
    sortList({ column, property, order }) {
      if (order) {
        this.listQuery.sortField = property;
        this.listQuery.sortType = order;
      } else {
        this.listQuery.sortField = "";
        this.listQuery.sortType = "";
      }
      this.findList();
    },
    funcAdd(type, code) {
      // TODO: 打开新增/编辑弹窗
      this.$message.info("功能开发中");
    },
    funcDelete(code) {
      this.$confirm("确认删除吗？")
        .then(() => {
          // TODO: 调用删除接口
          this.$message.success("删除成功");
          this.findList();
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
.vxe-toolbar {
  padding: 0 0 10px 0;
}
.add-form {
  padding: 30px 30px 10px;
}
.modal-footer {
  text-align: right;
}
</style>
